import { useEffect, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';

export default function GroupStats({ groupId, refresh }) {
  const [totalLessons, setTotalLessons] = useState(0);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    axios.get('/api/lessons?groupe=' + groupId, { withCredentials: true })
      .then(response => setTotalLessons((response.data || []).length))
      .catch(() => {});
    axios.get('/api/events/infopanel?groupe=' + groupId, { withCredentials: true })
      .then(response => setParticles(response.data || []))
      .catch(() => {});
  }, [groupId, refresh]);

  const particleValue = (name) => {
    const found = particles.find(p => p.name === name);
    return found ? found.value : '0';
  };

  const lang = language[language.lang];

  const tiles = [
    { value: totalLessons, label: lang.groupCard.statsTotalLessons },
    { value: particleValue('Sum hours'), label: lang['Sum hours'] },
    { value: particleValue('Sum price'), label: lang['Sum price'] },
    { value: particleValue('Sum attendance'), label: lang['Sum attendance'] },
    { value: particleValue('Sum absence'), label: lang['Sum absence'] },
    { value: particleValue('Sum paid'), label: lang['Sum paid'] },
  ];

  return (
    <div className="group-card-stats-row">
      {tiles.map((tile, index) => (
        <div className="conv-progress-stat" key={index}>
          <span className="conv-progress-stat-value">{tile.value}</span>
          <span className="conv-progress-stat-label">{tile.label}</span>
        </div>
      ))}
    </div>
  );
}
